import React from 'react';
import { Link } from 'react-router-dom';
import { GameCard } from '../features/product/types';
import ProductCard from './ProductCard';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel';

interface ProductCarouselProps {
  products: GameCard[];
  // Path prefix for a card link. Games -> "/product", services -> "/service".
  hrefBase?: string;
  viewAllHref?: string;
  viewAllLabel?: string;
  imageAndNameOnly?: boolean;
}

const ProductCarousel: React.FC<ProductCarouselProps> = ({
  products,
  hrefBase = '/product',
  viewAllHref,
  viewAllLabel = 'Смотреть всю подборку',
  imageAndNameOnly = false,
}) => {
  return (
    <Carousel
      opts={{ align: 'start', slidesToScroll: 'auto' }}
      className="w-full"
    >
      <div className="mb-3 flex justify-end gap-2 md:hidden">
        <CarouselPrevious
          aria-label="Предыдущие товары"
          className="static h-11 w-11 translate-y-0 rounded-full border-foreground/25 bg-transparent text-foreground hover:bg-muted hover:text-foreground"
        />
        <CarouselNext
          aria-label="Следующие товары"
          className="static h-11 w-11 translate-y-0 rounded-full border-foreground/25 bg-transparent text-foreground hover:bg-muted hover:text-foreground"
        />
      </div>
      <CarouselContent className="-ml-2 sm:-ml-[18px]">
        {products.map((product) => (
          <CarouselItem
            key={product.id}
            className="pl-2 sm:pl-[18px] basis-1/2 md:basis-1/3 lg:basis-1/4 xl:basis-1/6 h-auto"
          >
            <ProductCard product={product} hrefBase={hrefBase} imageAndNameOnly={imageAndNameOnly} />
          </CarouselItem>
        ))}
        {viewAllHref && (
          <CarouselItem className="h-auto basis-1/2 pl-2 sm:pl-[18px] md:basis-1/3 lg:basis-1/4 xl:basis-1/6">
            <Link
              to={viewAllHref}
              className="group flex h-full min-h-[280px] flex-col items-center justify-center rounded-[20px] border border-red-500/20 bg-[linear-gradient(145deg,rgba(239,68,68,0.14),rgba(239,68,68,0.03))] px-5 text-center transition-colors hover:border-red-500/45 sm:min-h-[360px] sm:rounded-[28px]"
            >
              <span className="text-lg font-semibold leading-tight text-foreground transition-colors group-hover:text-red-500">{viewAllLabel}</span>
            </Link>
          </CarouselItem>
        )}
      </CarouselContent>
      <CarouselPrevious className="hidden md:flex border-foreground/20 bg-foreground/10 text-foreground hover:bg-foreground/20 hover:text-foreground" />
      <CarouselNext className="hidden md:flex border-foreground/20 bg-foreground/10 text-foreground hover:bg-foreground/20 hover:text-foreground" />
    </Carousel>
  );
};

export default ProductCarousel;
